// @flow

import React, { Component } from "react";
import classNames from "classnames";
import { localize } from "redux-i18n";
import type { WidgetProps } from "@rjsf/utils";

type Props = $Exact<{
  ...WidgetProps,
  options: Object,
}>;

class TextWidget extends Component<Props> {
  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;

    this.props.onChange(value);
  };

  render() {
    const props = {
      ...this.props,
      ...this.props.options,
      ...(this.props.schema && this.props.schema.hasOwnProperty("minimum")
        ? { min: this.props.schema.minimum }
        : {}),
      ...(this.props.schema && this.props.schema.hasOwnProperty("maxLength")
        ? { maxLength: this.props.schema.maxLength }
        : {}),
      onChange: this.handleChange,
      value: this.props.value || "",
    };

    //TODO: why ?
    const shouldHighlightRequired =
      this.props.required &&
      !this.props.value &&
      (!this.props.rawErrors || !this.props.rawErrors.length);
    const value = props.disabled && !props.value ? this.props.t("N/A") : props.value;

    return (
      <div className={classNames("schema-form-widget-text", {})}>
        <input
          type="text"
          id={props.id}
          name={props.id}
          disabled={props.disabled}
          readOnly={props.readonly}
          maxLength={props.maxLength}
          minLength={props.minLength}
          placeholder={props.placeholder}
          onChange={this.handleChange}
          value={value}
          className={["form-control", this.props.className || ""].join(" ")}
        />
      </div>
    );
  }
}

export default localize()(TextWidget);
